// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2dU_a","location":"Header_location__1UjJv"};